/* === LINE URL 広告経路振り分け + attribution beacon === */
(function(){
  var map = {
    google_pmax:    'https://lin.ee/VsHgDtt',
    google_listing: 'https://lin.ee/7vzL7Rq',
    meta_reel:      'https://lin.ee/OOnEZYi',
    meta_photo:     'https://lin.ee/vetOjNR'
  };
  var fallback = 'https://lin.ee/8tXU7y1';
  var BEACON_URL = 'https://misty-ninette-adavdav-70fe7799.koyeb.app/api/attribution';
  // utm_source をcookieに保存（30日間）
  var params = new URLSearchParams(location.search);
  var src = params.get('utm_source');
  if (src) {
    document.cookie = 'pz_utm_source=' + encodeURIComponent(src) + ';path=/;max-age=' + (30*24*60*60) + ';SameSite=Lax';
    // utm_medium / utm_campaign も同じ規則で保存する（デザインシミュレーターのエディタに流入元として渡す。assets/pz-design-embed.js）。
    // 新しい utm_source が来たら3つとも入れ替える。medium / campaign が無い着地なら消して、前の訪問のものと混ざらないようにする。
    // 値は小文字・[a-z0-9_.-] だけ・40文字まで（pz-design-embed.js と snippets/pz-design-embed.liquid の読み取りと同じ）
    ['utm_medium', 'utm_campaign'].forEach(function(k){
      var v = String(params.get(k) || '').toLowerCase().replace(/[^a-z0-9_.-]/g, '').slice(0, 40);
      document.cookie = 'pz_' + k + '=' + v + ';path=/;max-age=' + (v ? 30*24*60*60 : 0) + ';SameSite=Lax';
    });
  }
  // cookieから取得
  var saved = (document.cookie.match(/(?:^|;\s*)pz_utm_source=([^;]*)/) || [])[1] || '';
  saved = decodeURIComponent(saved);
  var lineUrl = map[saved] || fallback;
  // LP（pages/b2b-for-teams-lp）は中身がシャドウDOMの中にあり、document.querySelectorAll が届かない。
  // 開いているシャドウルートの中のリンクにも beacon を付ける（2026-10-05。それまで LP からの LINE は全部 LINE_direct だった）
  function shadowRoots(){
    var roots = [];
    document.querySelectorAll('*').forEach(function(el){ if (el.shadowRoot) roots.push(el.shadowRoot); });
    return roots;
  }
  // 全 LINE リンクを書き換え + クリック時にbeacon送信
  document.addEventListener('DOMContentLoaded', function(){
    var links = [];
    document.querySelectorAll('a[href*="lin.ee/"]').forEach(function(a){ a.href = lineUrl; links.push(a); });
    // シャドウDOMの中（LP）は、振り分け先が決まっている経路のときだけ書き換える（それ以外は LP 専用の lin.ee のまま）
    shadowRoots().forEach(function(root){
      root.querySelectorAll('a[href*="lin.ee/"]').forEach(function(a){ if (map[saved]) a.href = map[saved]; links.push(a); });
    });
    links.forEach(function(a){
      // LINEリンククリック時にattribution beaconを送信
      a.addEventListener('click', function(){
        // UTM有無に関わらず全クリックを計測
        if (typeof gtag === 'function') {
          gtag('event', 'line_button_click', {utm_source: saved || 'none'});
          // Google 広告の成果「LINE問い合わせ」（入札・判断に使う成果。2026-10-10）
          gtag('event', 'conversion', {send_to: 'AW-11227445139/BCwpCKP2yfsYEJPv1Okp', transport_type: 'beacon'});
        }
        // beaconはUTMある時だけ。text/plain=CORS preflight回避（application/jsonだと
        // sendBeaconのcredentials込みpreflightがブロックされ届かない。2026-08-20修正）
        if (saved) {
          var blob = new Blob([JSON.stringify({src: saved})], {type: 'text/plain'});
          navigator.sendBeacon(BEACON_URL, blob);
        }
      });
    });
    // mailtoリンクをプラスアドレス（UTMトラッキング用）に書き換え
    var mailSuffixMap = {
      google_pmax:    'gp',
      google_listing: 'ls',
      meta_photo:     'mp',
      meta_reel:      'rl'
    };
    document.querySelectorAll('a[href^="mailto:"]').forEach(function(a){
      if (!saved) return;
      var suffix = mailSuffixMap[saved];
      if (suffix) {
        // contact@printeez.jp → contact+gp@printeez.jp
        a.href = a.href.replace(/^(mailto:[^+?@]+)([?@].*)$/, '$1+' + suffix + '$2');
      }
    });
  });
})();
